<form [formGroup]="form">
  <div class="p-fluid">
    <kodit-field
      fieldLabelFor="opisPromet20Obj"
      fieldLabel="Opis"
      class="flex-50 p-mt-4"
    >
      <kodit-textarea-input
        formCtrlId="opisPromet20Obj"
        [formCtrl]="form.controls.razlog"
      ></kodit-textarea-input>
    </kodit-field>

  </div>
</form>
